export default __webpack_public_path__ + "static/media/on-boarding@2x.695a517b.png";